import React from 'react';
import PropTypes from 'prop-types';

const X02 = ({color = 'currentColor', ...props}) => (
  <svg
    width="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M22 2L2 22M22 22L2 2" stroke={color} strokeWidth="3.33333" strokeLinecap="round"/>
  </svg>
);

X02.propTypes = {
  color: PropTypes.string,
};

export default X02;
